export default "__VITE_ASSET__DTqcqnDn__"